import { useApplicationModals } from "app/common/hooks";
import { Button, IconButton } from "app/components/atoms/button";
import { InputLabel } from "app/components/atoms/form";
import { InputMolecule } from "app/components/molecules/form";
import { ModalMolecule } from "app/components/molecules/modal";
import api, { stockOpname } from "app/integration/api";
import { useCollector, useCreateForm } from "app/integration/common/hooks";
import { Formik, getIn } from "formik";
import * as Yup from "yup";
import AppModals from ".";
import { useState, useRef, useCallback, useEffect } from "react";
import Table from "app/components/atoms/table";
import { SelectMolecule, SelectSearchMolecule } from "app/components/molecules/select";
import { TrashIcon } from "@heroicons/react/24/outline";

function CreateStockOpname({ onSuccess = () => { } }) {
  let isError = false;
  const { showStates, closeModal, getPayloads, openModal, setPayloads } =
    useApplicationModals();

  const handleClose = () => {
    closeModal("stockOpname.create");
  };
  const handleSuccess = () => {
    closeModal("stockOpname.create");
    onSuccess();
  };

  const [productVariants] = useCollector({ modelName: "productVariant" });

  const makeid = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  const { initialValues, validationSchema, onSubmit, setFieldValue } = useCreateForm({
    initialValues: {
      product_variant_id: null,
      physical_stock: 0,
      description: "",
    },
    validationSchema: Yup.object().shape({
      product_variant_id: Yup.number().required("Variant harus diisi"),
      physical_stock: Yup.number().required("Stok fisik harus diisi")
        .min(1, "Stok fisik harus lebih dari 0."),
      description: Yup.string().optional(),
    }),
    onSubmit: async (values) => {
      try {
        const productVariant = productVariants.find(
          (item) => item.id === values?.product_variant_id
        );
        
        await api.stockOpname.store(
          makeid(10),
          [],
          productVariant?.product_detail?.name,
          values.product_variant_id,
          null,
          values.physical_stock,
          new Date(),
          values.description,
          "approved"
        );
        isError = false;
      } catch (error) {
        setPayloads("errorMessage.view", {
          title: "Add Stock Opname Error",
          message: error?.response?.data?.message,
        });
        isError = true;
        openModal("errorMessage.view");
      }
    },
    onSuccess: () => {
      if (!isError) {
        handleSuccess();
      }
    },
  });

  return (
    <ModalMolecule
      show={showStates["stockOpname.create"]}
      title="Tambah Stock Opname"
      onClose={handleClose}
    >
      <AppModals
        items={["errorMessage.view"]}
        onSuccess={{
          "errorMessage.view": () => fetch(),
        }}
      />
      <Formik
        {...{ initialValues, validationSchema, onSubmit }}
        enableReinitialize={true}
      >
        {({
          values,
          errors,
          status,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form className="space-y-4 pb-24" onSubmit={handleSubmit}>
            <SelectSearchMolecule testId="modal-create-stock-opname-product-variant-id-select"
              label="Produk Variant"
              name="product_variant_id"
              options={productVariants?.map((productVariant) => ({
                value: productVariant?.id,
                label: `${productVariant?.product_detail?.name} (${productVariant?.color?.name}) (${productVariant?.size?.name})`,
              }))}
              onChange={(e) => {
                handleChange(e);
              }}
              onBlur={handleBlur}
              value={values.product_variant_id}
              errorMessage={
                errors.product_variant_id &&
                touched.product_variant_id &&
                errors.product_variant_id
              }
            />
            <InputMolecule testId="modal-create-stock-opname-description-input"
              label="Keterangan"
              type="text"
              name="description"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.description}
              errorMessage={
                errors.description &&
                touched.description &&
                errors.description
              }
            />
            <InputMolecule testId="modal-create-stock-opname-physical-stock-input"
              label="Jumlah"
              type="number"
              name="physical_stock"
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.physical_stock}
              errorMessage={
                errors.physical_stock &&
                touched.physical_stock &&
                errors.physical_stock
              }
            />

            <div className="fixed bottom-2 left-0 sm:left-auto right-0 sm:right-4 sm:bottom-4 sm:w-auto z-40 flex justify-end border-t border-gray-100 bg-white sm:bg-transparent p-4 sm:p-0 dark:border-gray-700 dark:bg-gray-800 print:hidden sm:absolute sm:rounded-b-lg sm:border-0 ">
              <Button testId="modal-create-stock-opname-submit-button" type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Menyimpan...' : 'Simpan'}
              </Button>
            </div>
          </form>
        )}
      </Formik>
    </ModalMolecule>
  );
}

export default CreateStockOpname;
